/*
 * Copyright (c) 2025. Sergey S. Chernov - All Rights Reserved
 *
 *  You may use, distribute and modify this code under the
 * terms of the private license, which you must obtain from the author
 *
 * To obtain the license, contact the author: https://t.me/real_sergeych or email to
 * real dot sergeych at gmail.
 */

package net.sergeych.crypto2

import kotlin.time.Instant

interface SigningKey: KeyInstance {
    val verifyingKey: VerifyingPublicKey
    fun sign(message: UByteArray): UByteArray
    fun seal(message: UByteArray, expiresAt: Instant? = null): Seal
}